import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const cards = [
  {
    number: '01',
    title: 'REPORTS',
    description: 'We can refine and optimise your strategies against years of historical data.',
    link: '/backtesting',
    accent: 'text-[#ff4ca3]',
  },
  {
    number: '02',
    title: 'CODE',
    description: 'Let us automate your trading execution so you never miss out on a trade.',
    link: '/automation',
    accent: 'text-[#f5b84b]',
  },
  {
    number: '03',
    title: 'SIGNALS',
    description: 'Receive realtime push notifications when our automated strategies place trades.',
    link: '/signals',
    accent: 'text-[#20c7ff]',
  },
];

const HomeCardsV2 = () => {
  return (
    <section className="w-full text-white">
      <div className="mx-auto grid max-w-[1090px] border border-white/5 grid-cols-1 overflow-hidden rounded-lg bg-transparent md:grid-cols-3 mb-24">
        {cards.map((card, index) => (
          <Link
            key={card.title}
            to={card.link}
            className="group relative flex min-h-[138px] items-center px-5 py-6 text-left transition duration-300 hover:bg-white/[0.025] focus:outline-none focus:ring-2 focus:ring-[#00df9a] focus:ring-inset md:px-6 lg:px-7"
          >
            <div className="min-w-0 pr-10">
              <p className={`text-xs font-bold leading-none tracking-[0.14em] ${card.accent}`}>
                {card.number}
              </p>

              <h3 className="mt-3 text-lg font-extrabold leading-none text-white md:text-xl">
                {card.title}
              </h3>
              <p className="mt-2 max-w-[255px] text-xs font-medium leading-[1.45] text-white/55">
                {card.description}
              </p>
            </div>

            <FiArrowRight
              className="absolute right-5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#008d68] transition duration-300 group-hover:translate-x-1 group-hover:text-[#00df9a] md:right-6"
              aria-hidden="true"
            />
          </Link>
        ))}
      </div>
    </section>
  );
};

export default HomeCardsV2;
